import { RgChildren as u, GetAllBones as v } from "@project-rouge/rg-core";
import { getBoundaryOfObjects as h } from "../index4.js";
import { offsetPolygon as B } from "../../../geometry-utils/clipper-utils/index5.js";
import { differencePolygons as A } from "../../../geometry-utils/clipper-utils/index3.js";
import { Vector3 as p } from "three";
import { isPointInside as I } from "../../../geometry-utils/core/index19.js";
const c = new p(), d = new p(), y = new p();
let l = [], g = !1;
function j(o, n) {
  const m = o.children.filter((e) => e.data.levelId === n.uuid);
  let s = h(m, [...u.Building]), r = v(o.data.anatomy).filter((e) => !n.bones.includes(e.id) && e.floors > n.levelIndex).map((e) => {
    const i = o.data.levels.find((a) => a.bones.includes(e.id) && a.levelIndex === n.levelIndex), P = o.children.filter((a) => a.data.levelId === i.uuid);
    return h(P, [...u.Building]);
  });
  s = A(s, r)[0], r = r.map((e) => B(e, 0.1));
  const t = [];
  for (let e = 0; e < s.length; e++)
    w(e, s, t, r);
  if (l.length > 0 && (t.push(l), l = []), t.length > 1) {
    const e = t[0], i = t[t.length - 1];
    c.fromArray(e[0]), d.fromArray(i[i.length - 1]), c.equals(d) && (t.shift(), t[t.length - 1] = i.concat(e));
  }
  return t;
}
const w = (o, n, m, s) => {
  const f = n[o];
  if (o === n.length - 1) {
    l.push(f);
    return;
  }
  c.fromArray(f), d.fromArray(n[o + 1]), y.addVectors(c, d).multiplyScalar(0.5);
  const r = s.some((t) => I(y, t));
  if (r && g) {
    if (l.length === 0)
      return;
    m.push(l), l = [];
  } else
    l.push(f);
  g = r;
};
export {
  j as getRoofFacadePerimeter
};
//# sourceMappingURL=index.js.map
